// Media Availability: which generated media this build can produce.
//
// A Standalone Install generates no images for now: scene images, scene maps,
// stage cutouts, card art, NPC portraits, and the image settings and hotkeys are
// off there. The player's own portrait button stays, and its request fails with
// "Image generation is not available" until standalone image generation lands.
// Sound effects and voice input are off too; narration comes through the
// gateway (ElevenLabs on OpenRouter).
//
// A standalone portrait is optional. The gateway can be unreachable, and the
// player must still be able to finish a text-only character, so a portrait is
// only required where IMAGES_AVAILABLE (hosted).
//
// Surfaces read these flags instead of IS_STANDALONE so each media decision
// stays in one place: anything that would wait on an image it cannot get takes
// its no-image path up front, before the player's preferences have even loaded.
//
// Derived from the build-time Runtime Profile, so these are compile-time constants
// and the hosted build is unchanged.
import { IS_STANDALONE } from './runtimeProfile.js';

// Scene images, scene maps, stage cutouts, card art, NPC portraits, image
// settings and hotkeys, and the hosted portrait requirement.
export const IMAGES_AVAILABLE = !IS_STANDALONE;
// A player generating the portrait of their own character: hosted through
// Runware; a Standalone Install's request fails until it has image generation.
export const PLAYER_PORTRAITS_AVAILABLE = true;
export const SOUND_EFFECTS_AVAILABLE = !IS_STANDALONE;
export const SPEECH_TO_TEXT_AVAILABLE = !IS_STANDALONE;
